var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:(_vm.position === 1 ? _vm.getNumberStyle() : _vm.getTitleStyle())},[_vm._v(_vm._s(_vm.position === 1 ? _vm.value : _vm.title))]),_c('div',{style:(_vm.position === 1 ? _vm.getTitleStyle() : _vm.getNumberStyle())},[_vm._v(_vm._s(_vm.position === 1 ? _vm.title : _vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }